import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { ISystem } from 'src/app/domain/registration/models/ISystem';
import { ISystemModule } from 'src/app/domain/registration/models/ISystemModule';
import { DynamicFormComponent } from 'src/app/shared/components/dynamic-form/containers/dynamic-form/dynamic-form.component';
import { SystemService } from '../../systems/crud-service';
import { CES_CONFIG_FIELDS } from '../crud-config';
import { PermissionService } from 'src/app/shared/permission.service';

@Component({
  selector: 'app-system-module-ces',
  templateUrl: './crud-ces.component.html',
  styleUrls: ['./crud-ces.component.sass'],
  providers: [SystemService],
})
export class SystemModuleCESComponent implements OnInit {
  @ViewChild(DynamicFormComponent) form: DynamicFormComponent;
  config: IFieldConfig[] = CES_CONFIG_FIELDS;
  data: ISystemModule;
  type: TypeCesEnum;
  title = '--';

  get typeCesEnum() {
    return TypeCesEnum;
  }

  setFields() {
    // PADRÃO
    this.form.setDisabled('submit', true);
    this.form.setValue('id', this.data?.id);
    // NA CÓPIA ALTERA APENAS ESSES
    this.form.setValue('system', this.data?.system);
    this.form.setValue('name', this.data?.name);
  }

  constructor(
    public permissionService: PermissionService,
    public dialogRef: MatDialogRef<SystemModuleCESComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: { type: TypeCesEnum; element: ISystemModule },
    private cdr: ChangeDetectorRef,
    private systemService: SystemService
  ) {
    this.type = data.type;
    this.data = data.element;
    this.title = this.type;
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    let previousValid = this.form.valid;

    this.form.changes.subscribe(() => {
      if (this.form.valid !== previousValid) {
        previousValid = this.form.valid;
        this.form.setDisabled('submit', !previousValid);
      }
    });

    this.setFields();
    this.cdr.detectChanges();
  }

  onSubmit(value: { [name: string]: any }) {
    this.systemService
      .listAll({ limit: 1000, page: 0, filter: '' })
      .subscribe(([data, length]: any) => {
        value['system'] = data.find(
          (item: ISystem) => item.name == value['system']
        );

        value['systemId'] = value['system'].id;
        value['system'] = value['system'].name;
        value['name'] = value['name'].toUpperCase();

        this.dialogRef.close({ element: value });
      });
  }

  onCancel() {
    this.dialogRef.close();
  }

  changeType(type: TypeCesEnum) {
    this.type = type;
    this.dialogRef.close({ changeType: type });
  }

  delete() {
    this.dialogRef.close({ delete: true });
  }
}
